import { setPositionsData } from '../redux/reducer/history';

// Create worker instance (singleton)
let workerInstance = null;
let messageQueue = [];
let isProcessing = false;

/**
 * Get or create worker instance
 */
const getWorker = () => {
  if (!workerInstance) {
    workerInstance = new Worker(
      new URL(
        '../components/trading-histories/history/precess/processPositionWorker.js',
        import.meta.url
      )
    );
  }
  return workerInstance;
};

/**
 * Process deals using web worker
 * @param {Function} dispatch - Redux dispatch function
 * @param {Array} dealsList - Array of deal items to process
 */
const setHistoryHandler = (dispatch, dealsList) => {
  if (!dealsList || dealsList.length === 0) {
    return;
  }

  const worker = getWorker();

  // Add to queue
  messageQueue.push({ dispatch, deals: dealsList });

  // Process queue if not already processing
  if (!isProcessing) {
    processQueue();
  }
};

/**
 * Process the message queue
 */
const processQueue = () => {
  if (messageQueue.length === 0) {
    isProcessing = false;
    return;
  }

  isProcessing = true;
  const { dispatch, deals } = messageQueue.shift();
  const worker = getWorker();

  // Set up one-time message handler for this batch
  const handleMessage = (e) => {
    const { type, payload } = e.data;

    switch (type) {
      case 'DEALS_PROCESSED': {
        const { positions } = payload;
        if (positions.length > 0) {
          dispatch(setPositionsData(positions.filter((e) => e.isClosed)));
        }
        // Remove this handler and process next
        worker.removeEventListener('message', handleMessage);
        processQueue();
        break;
      }

      case 'ERROR': {
        console.error('Worker error:', payload);
        worker.removeEventListener('message', handleMessage);
        processQueue();
        break;
      }

      default:
        break;
    }
  };

  // Add message listener
  worker.addEventListener('message', handleMessage);

  // Send deals to worker for processing
  worker.postMessage({
    type: 'PROCESS_DEALS',
    payload: { deals }
  });
};

/**
 * Process single item (for real-time updates)
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} item - Single deal item
 */
export const processSingleItem = (dispatch, item) => {
  const worker = getWorker();

  // Determine action type based on item properties
  if (item.entry === 0 && item.action < 2) {
    // Initialize position
    worker.postMessage({
      type: 'INIT_POSITION',
      payload: { deal: item }
    });
  } else if (item.entry === 0 && (item.action === 2 || item.action === 3 || item.action === 19)) {
    // Add real position (balance operation)
    worker.postMessage({
      type: 'INIT_POSITION',
      payload: { deal: item }
    });
  } else if (item.entry > 0 && item.action < 2) {
    // Update position - needs existing position data
    // This would require fetching the position from state first
    console.log('Update position:', item);
  }
};

/**
 * Terminate worker (cleanup)
 */
export const terminateHistoryWorker = () => {
  if (workerInstance) {
    workerInstance.terminate();
    workerInstance = null;
    messageQueue = [];
    isProcessing = false;
  }
};

export default setHistoryHandler;
